import Container from "components/general/Container";
import PageHeader from "components/general/Headers/PageHeader";
import PageLoader from "components/general/PageLoader";
import ScrollContainer from "components/general/ScrollContainer";
import Section from "components/general/Section";
import Seo from "components/general/Seo";
import InvoiceTable from "components/orders/InvoiceTable";
import { Box, Button, Typography } from "components/ui";
import { BadgeDollarSign } from "lucide-react-native";
import React from "react";
import { ActivityIndicator } from "react-native";
import { Pagination } from "react-native-swiper-flatlist";
import { useGetCompanyQuery, useGetInvoiceQuery } from "store/abcoApi";
export default function Page() {
	const [pageNumber, setPageNumber] = React.useState(1);
	var { data: company, isLoading } = useGetCompanyQuery();
	var {
		data: invoiceCollection,
		isLoading: isInvoiceLoading,
		isFetching,
	} = useGetInvoiceQuery({
		pageNumber,
	});

	if (isLoading) {
		return <PageLoader />;
	}

	if (!company) {
		return <Box>Company not found</Box>;
	}

	return (
		<ScrollContainer>
			<Seo title="Finance | Abconet" description="" />
			<Container>
				<Box flexDirection="row" justifyContent="space-between">
					<PageHeader title="Finance" description="" />
					{company?.paymentUrl && (
						<Box paddingHorizontal={48} paddingVertical={48}>
							<Button gap={8} w="fit-content" isLink variant="secondary" href={company?.paymentUrl}>
								<Typography sx={{ color: "$basicblack" }}>Pay Now</Typography>
								<BadgeDollarSign color="black" size={24} />
							</Button>
						</Box>
					)}
				</Box>
				<Section>
					{isFetching ? (
						<Box minHeight={200} justifyContent="center" alignItems="center" bg="transparent">
							<Box flex={1} justifyContent="center">
								<ActivityIndicator size="large" style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }] }} />
							</Box>
						</Box>
					) : (
						invoiceCollection != null && <InvoiceTable dataList={invoiceCollection.list} />
					)}
					<Box justifyContent="center" marginTop={30} alignItems="center">
						<Pagination pageCount={invoiceCollection?.metaData?.pageCount} pageNumber={invoiceCollection?.metaData?.pageNumber} onChangePage={setPageNumber} />
					</Box>
				</Section>
			</Container>
		</ScrollContainer>
	);
}
